define('model/GroupedTimeSlotsModel',['require','backbone'],function (require) {

    var Backbone = require('backbone');

    /**
     * Grouped time slots. Contains time slots collection.
     *
     * @class TimeFlexibleModel
     */
    return Backbone.Model.extend({

        defaults: {
            collection: '',
            time: '',
            date: '',
            provider_id: ''
        },

        toJSON: function (options) {
            var result = Backbone.Model.prototype.toJSON.apply(this, [options]);
            result.datetime = Date.parseMysqlDate(this.get('date') + ' ' + this.get('time'));

            return result;
        }

    });

});
